import React, { useState, useEffect, useRef } from "react";
import { Modal, Form } from "react-bootstrap";
import CommonButton from "../../commonButton";
import withModal from "../../withModal";
import { useToast } from "../../../context/TostContext";
import { Delete02Icon } from "../../../assets/icons";
import InputField from "../../form/InputField";

const TestimonialModal = ({ onClose, onSubmit, testimonial, isLoading }) => {
  const [formData, setFormData] = useState({
    name: "",
    description: "",
  });
  const toast=useToast();
  const [file, setFile] = useState(null);
  const [filePreview, setFilePreview] = useState(null);
  const fileInputRef = useRef(null);

  useEffect(() => {
    if (testimonial) {
      setFormData({
        name: testimonial.name || "",
        description: testimonial.description || "",
      });
      setFile(null);
      setFilePreview(testimonial.file?.url || null);
    } else {
      setFormData({
        name: "",
        description: "",
      });
      setFile(null);
      setFilePreview(null);
    }
  }, [testimonial]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      if (selectedFile.size > 5 * 1024 * 1024) {
        toast.error("File size should be less than 5MB");
        return;
      }
      setFile(selectedFile);
      setFilePreview(URL.createObjectURL(selectedFile));
    }
  };

  const handleRemoveFile = () => {
    setFile(null);
    setFilePreview(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };


  const handleSubmit = (e) => {
    e.preventDefault();
    if (isLoading) return;

    if (!formData.name) {
      toast.error("Please enter a name");
      return;
    }

    if (!filePreview) {
      toast.error("Please upload a photo/logo");
      return;
    }

    const submitData = new FormData();
    submitData.append("name", formData.name);
    submitData.append("description", formData.description);

    if (file) {
      submitData.append("file", file);
    }

    onSubmit(submitData);
  };

  return (
    <Form onSubmit={handleSubmit} noValidate>
      <Modal.Body className="grid row-gap-3">
        <InputField
          className="g-col-12"
          label={{ name: "Person Name" }}
          required
          input={{
            type: "text",
            name: "name",
            value: formData.name,
            onChange: handleChange,
            placeholder: "Ex: John Doe",
          }}
        />
        <InputField
          className="g-col-12"
          label={{ name: "Description" }}
          input={{
            as: "textarea",
            rows: 4,
            name: "description",
            value: formData.description,
            onChange: handleChange,
            placeholder: "Write the testimonial here...",
          }}
        />
        <Form.Group className="g-col-12">
          <Form.Label>Photo / Logo <span className="text-danger">*</span></Form.Label>
          <div className="d-flex align-items-center gap-3">
            <div 
              className="award-file-upload border rounded-2 d-flex align-items-center justify-content-center cursor-pointer overflow-hidden position-relative"
              style={{ width: "100px", height: "100px", backgroundColor: "#f8f9fa" }}
              onClick={() => fileInputRef.current?.click()}
            >
              {filePreview ? (
                <>
                  <img src={filePreview} alt="Testimonial Preview" className="w-100 h-100 object-fit-cover" />
                  <button
                    type="button"
                    className="position-absolute top-0 end-0 bg-danger text-white border-0 p-1 d-flex align-items-center justify-content-center"
                    style={{ borderBottomLeftRadius: "4px" }}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleRemoveFile();
                    }}
                  >
                    <Delete02Icon width={14} height={14} color="#FFFFFF" />
                  </button>
                </>
              ) : (
                <span className="text-muted small">Upload</span>
              )}
            </div>
            <input
              type="file"
              ref={fileInputRef}
              onChange={handleFileChange}
              accept="image/*"
              className="d-none"
            />
          </div>
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <CommonButton
          type="button"
          variant="outline"
          title="Cancel"
          onClick={onClose}
          disabled={isLoading}
        />
        <CommonButton
          type="submit"
          variant="primary"
          title={testimonial ? "Update" : "Save"}
          isLoading={isLoading}
        />
      </Modal.Footer>
    </Form>
  );
};

export default withModal(TestimonialModal);
